import React from 'react'
import Modal from 'react-modal'
import styles from '../../styles/backyard/common/Modal.module.sass'
// import Loading from './Loading'

/**
 * モーダルの共通コンポーネント
 */
type Props = JSX.IntrinsicElements[`div`] & {
  id: string
  isOpen: boolean
  isLoading?: boolean
  className?: string
  customOverlayClassName?: string
  appElementName: string
  onClickCloseButton?: () => void
}
const ModalWrapper = (props: Props) => {
  const {
    id,
    isOpen,
    isLoading = false,
    className = null,
    onClickCloseButton = null,
    appElementName,
    customOverlayClassName = ``,
  } = props

  Modal.setAppElement(appElementName)

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      bodyOpenClassName={styles.modalBackground}
      overlayClassName={`${styles.modalWrapper} ${customOverlayClassName}`}
      className={`${className} ${isLoading ? styles.loading : ``}`}
    >
      {onClickCloseButton && (
        <div className={styles.close}>
          <span className={`${styles.closeButton} material-icons`} onClick={onClickCloseButton}>
            clear
          </span>
        </div>
      )}
      {props.children}
      {/* {isLoading && <Loading.LoadingContent />} */}
    </Modal>
  )
}

export default ModalWrapper
